import factory from './icon';
import Svg from './glyphs/menu-burger.svg';

export default factory(Svg);
